import { FC } from "react";
import { FeatureItemType } from "../../../../../../types/Other";
import { Input, Label } from "reactstrap";
import { No, Yes } from "../../../../../../constants";

const FeatureItem: FC<FeatureItemType> = ({ label, name }) => {
  return (
    <li>
      <span>{label}</span>
      <div className="flex-radio">
        <Input type="radio" name={name} id={`${name}-yes`} />
        <Label htmlFor={`${name}-yes`}>{Yes}</Label>
      </div>
      <div className="flex-radio">
        <Input type="radio" name={name} id={`${name}-no`} />
        <Label htmlFor={`${name}-no`}>{No}</Label>
      </div>
    </li>
  );
};

export default FeatureItem;
